import {cva} from 'class-variance-authority'

/**
 * Tooltip bubble (Figma "<Tooltip>", node 324:15170 — MUI Tooltip).
 * Dark-teal `primary-contrast` (#004E56, the `_components/tooltip/fill` token) fill,
 * white `text-inverse` label at the 10px `tooltip` type token, 8px radius.
 */
// Portals to <body>; `z-[1500]` (MUI's tooltip tier, above drawer 1200 / modal
// 1300 / snackbar 1400) keeps it visible over overlays. `z-50` hid it behind them.
export const TooltipVariantsFactory = cva(
  'z-[1500] max-w-xs rounded-lg bg-primary-contrast px-2 py-1 text-text-inverse',
  {
    // Same padding at both sizes; the bubble grows with the text.
    variants: {size: {small: 'text-tooltip', medium: 'text-body2'}},
    defaultVariants: {size: 'small'},
  },
)
